import {useEffect} from "@wordpress/element";
import {Box, useMantineTheme} from "@mantine/core";

export default function BuildHistory(){

    const theme = useMantineTheme();

    useEffect(() => {
        if(window.appzaPremium){
            window.appzaPremium.buildHistory(theme);
        }
    }, []);
    return(
        <Box id="appza-app-build-history"></Box>
    )
}